"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sink = void 0;
const SinkBuilder_1 = require("../SinkBuilder");
/**
 * class decorator for create sink
 * @param {string} [namespace]
 * name of the sink, also the state name in store, cannot be duplicated across sinks
 * @param {...*} [injects]
 * inject sink or objects like sink factory to sink constructor,
 * if inject with sink class, it will be auto resolved to sink object
 */
function sink(namespace, ...injects) {
    return function (constructor) {
        const prototype = constructor.prototype;
        const sinkBuilder = SinkBuilder_1.SinkBuilder.get(prototype);
        sinkBuilder.namespace = namespace;
        sinkBuilder.sinkConstructor = constructor;
        sinkBuilder.sinkInjects = injects;
        return constructor;
    };
}
exports.sink = sink;
